import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { Grid, Typography } from '@material-ui/core';

import { APPLICATION_DETAIL_ROUTE } from 'Console/constants/routes';
import { BROWSERS, BROWSERS_LINKS } from 'Console/constants/appConstants';
import pluginCjs from 'Console/assets/images/plugin-cjs.png';
import pluginJS from 'Console/assets/images/plugin-js-injector.png';

const styles = (theme) => ({
    root: {
        paddingTop: theme.typography.pxToRem(54),
    },
    title: {
        display: 'inline-block',
        fontWeight: 'bold',
        marginBottom: theme.typography.pxToRem(20),
    },
    message: {
        fontSize: theme.typography.pxToRem(14),
        marginBottom: theme.typography.pxToRem(25),
    },
    procedureList: {
        lineHeight: theme.typography.pxToRem(32),
    },
    pluginImage: {
        paddingLeft: theme.typography.pxToRem(4),
        paddingRight: theme.typography.pxToRem(4),
        verticalAlign: 'middle',
    },
    orderedList: {
        fontFamily: theme.typography.fontFamily,
    },
});

const FirefoxProcedure = ({ classes, browser, selectedApplication }) => (
    <Grid className={classes.procedureList}>
        <ol className={classes.orderedList}>
            <li>
                <Typography variant="body1">
                    <a target="_blank" href={BROWSERS_LINKS.FIREFOX} rel="noopener noreferrer">
                        <FormattedMessage id={`Settings.experiment.${browser}.step1.text`} />
                    </a>
                </Typography>
            </li>
            <li>
                <Typography variant="body1">
                    <FormattedMessage id={`Settings.experiment.${browser}.step2`} />
                </Typography>
            </li>
            <li>
                <Typography variant="body1">
                    <FormattedMessage id={`Settings.experiment.${browser}.step3a`} />{' '}
                    <Link
                        to={`${APPLICATION_DETAIL_ROUTE}${selectedApplication}/guides`}
                        target="_blank"
                    >
                        list of tours
                    </Link>{' '}
                    <FormattedMessage id={`Settings.experiment.${browser}.step3b`} />
                </Typography>
            </li>
            <li>
                <Typography variant="body1">
                    <FormattedMessage id={`Settings.experiment.${browser}.step4`} />
                </Typography>
            </li>
            <li>
                <Typography variant="body1">
                    <FormattedMessage id={`Settings.experiment.${browser}.step5a`} />
                    <img className={classes.pluginImage} alt="pluginImage2" src={pluginJS} />
                    <FormattedMessage id={`Settings.experiment.${browser}.step5b`} />
                </Typography>
            </li>
            <li>
                <Typography variant="body1">
                    <FormattedMessage id={`Settings.experiment.${browser}.step6`} />
                </Typography>
            </li>
            <li>
                <Typography variant="body1">
                    <FormattedMessage id={`Settings.experiment.${browser}.step7`} />
                </Typography>
            </li>
            <li>
                <Typography variant="body1">
                    <FormattedMessage id={`Settings.experiment.${browser}.step8a`} />{' '}
                    <b key="openingScriptTag">&lt;script&gt;</b>{' '}
                    <FormattedMessage id={`Settings.experiment.${browser}.step8b`} />{' '}
                    <b key="closingScriptTag">&lt;/script&gt;</b>{' '}
                    <FormattedMessage id={`Settings.experiment.${browser}.step8c`} />
                </Typography>
            </li>
            <li>
                <Typography variant="body1">
                    <FormattedMessage id={`Settings.experiment.${browser}.step9`} />
                </Typography>
            </li>
            <li>
                <Typography variant="body1">
                    <FormattedMessage id={`Settings.experiment.${browser}.step10`} />
                </Typography>
            </li>
            <li>
                <Typography variant="body1">
                    <FormattedMessage id={`Settings.experiment.${browser}.step11`} />
                </Typography>
            </li>
        </ol>
    </Grid>
);

const procedures = (browser, selectedApplication, intl, classes) => ({
    [BROWSERS.FIREFOX]: (
        <FirefoxProcedure
            intl={intl}
            browser={browser}
            selectedApplication={selectedApplication}
            classes={classes}
        />
    ),
});

const ExperimentWithoutIntegration = ({ classes, intl, browser, selectedApplication }) =>
    browser === 'firefox' ? (
        <Grid container className={classes.root}>
            <Grid item xs={12}>
                <Typography variant="subtitle1" className={classes.title}>
                    <FormattedMessage
                        id="Settings.experiment.title"
                        defaultMessage="Experiment with Adopt without integration"
                    />
                </Typography>
                <Typography variant="body1" className={classes.message}>
                    <FormattedMessage
                        id="Settings.experiment.message"
                        defaultMessage="Experiment with Adopt without integration"
                    />
                </Typography>
            </Grid>
            <Grid>{procedures(browser, selectedApplication, intl, classes)[browser]}</Grid>
        </Grid>
    ) : null;

export default withStyles(styles)(injectIntl(ExperimentWithoutIntegration));
